
import { Box, Button, Grid, Hidden, MenuItem, Popover, Stack, Typography, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Field, Form } from 'react-final-form'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import Container from '../../components/Container'
import { CountryCustom, NumbericInputCustom, TextFieldCustom } from '../../components/FormElements'
import Modal from '../../components/Modal'
import { config_path, portalCfg } from '../../router/config.path'
import validators from '../../utils/validators'
import PublicPage from '../PublicPage'
import { cache } from '../../utils/cache'
import { BackIcon } from '../../components/IconComponent'
import InitiatePage from '../InitiatePage'
import { GetIconColor } from '../../theme/main_style'

export default function LoginWithPhoneView(props) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const appConfig = cache.getAppConfig();
    const { palette } = useTheme();

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        // Clean up the event listener on component unmount
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const onBack = ()=>{
        navigate(config_path.login_register);
    }

    let optionsColour = null;
    if (palette.secondary.background.startsWith('#fff') || palette.secondary.background.startsWith('#000') ) 
    {
        optionsColour = palette.primary.main;
    }
    else if(palette.primary.main === palette.secondary.background)
    {
        optionsColour = '#ffffff'
    }
    else{
        optionsColour = palette.primary.main;
    }

    const { calling_country_default, login_info, calling_country, calling_countries } = props;

    const renderContent = () => {
        return (
            <>
                <Hidden mdUp>
                    <Stack onClick={onBack} style={{ cursor: 'pointer',position:"absolute",top:16,left:10 }} >
                        <BackIcon color={optionsColour}/>
                    </Stack>
                </Hidden>
                <Hidden mdDown>
                    <Stack onClick={onBack} style={{ cursor: 'pointer',position:"absolute",top:20,left:10 }} >
                        <BackIcon color={GetIconColor().primary}/>
                    </Stack>
                </Hidden>
                <Box
                    sx={{
                        position: {xs:'absolute', md: 'inherit'},
                        bottom: {xs:'0px', md: undefined},
                        backgroundColor: palette.background.paper,
                        borderRadius: '20px 20px 0px 0px',
                        p: 3, 
                        width: '100%',
                    }}>
                <Grid item xs={12} marginTop={4}>
                    <Form
                        onSubmit={props.onSubmit}
                        render={({ handleSubmit }) => (
                            <form onSubmit={handleSubmit}>
                                <Grid item xs={12}>
                                    <Grid item xs={12} container alignItems={'center'}>
                                        <Grid item xs={4}>
                                            <Field
                                                name="calling_country"
                                                component={CountryCustom}
                                                isEdit={true}
                                                selectData={calling_countries}
                                                defaultValueSelect={calling_country_default ? calling_country_default.value : null}
                                                valueSelect={login_info && login_info.calling_country ? login_info.calling_country : calling_country_default.value}
                                                onSelectedChange={(event) => props.onSelectCountry('calling_country', event.target.value)}
                                                placeholder={t(' ')}
                                                // isHideLabel={windowWidth < 768 ? true : false}
                                                noMargin={true}
                                                onlyFlag={windowWidth < 768 ? true : false}
                                            />
                                        </Grid>
                                        <Grid item xs={8} paddingLeft={1}>
                                            <Field
                                                name="phone_number"
                                                component={NumbericInputCustom}
                                                formatType='numeric'
                                                placeholder={t('phone_input_placeholder')}
                                                isEdit={true}
                                                validate={validators.composeValidators(validators.required, validators.mustBeNumberRequired)}
                                                startAdorment={<Typography>{calling_country && calling_country.phone_code ? '+' + calling_country.phone_code : undefined}</Typography>}
                                            />
                                        </Grid>
                                    </Grid>
                                    {/* <Grid item xs={12} container justifyContent={'flex-end'}>
                                        <Button id='loginPhone/btnForgotPassword' onClick={() => navigate(config_path.forgot_password)} variant='text'>{t('forgot_password')}</Button>
                                    </Grid> */}
                                    <Grid item xs={12} marginY={3}>
                                        <Button id='loginPhone/btnSubmit' fullWidth size="large" sx={{borderRadius:'30px'}} variant='contained' onClick={handleSubmit} type='submit'>{t('btn_login')}</Button>
                                    </Grid>
                                </Grid>
                            </form>
                        )}
                    />
                </Grid>
                </Box>
            </>
        )
    }

    return (
        <>
            <Hidden mdUp>
                <InitiatePage message={props.message} showProcessing={props.showProcessing} confirm={props.confirm} showLanguage useConfiguredLanguage>
                    {renderContent()}
                </InitiatePage>
            </Hidden>

            <Hidden mdDown>
                <PublicPage message={props.message} showProcessing={props.showProcessing} confirm={props.confirm} showLanguage useConfiguredLanguage>
                    {renderContent()}
                </PublicPage>
            </Hidden>
        </>
    )
}
